import { InjectionToken } from '@angular/core';

export const API_URL = new InjectionToken<string>('API Url');

export const ROUTER_API_URL = new InjectionToken<string>('Router API Url');

export const API_CELL_URL_TEMPLATE = new InjectionToken<string>(
  'Cell API Template Url',
);
